import { render, staticRenderFns } from "./researchHome.vue?vue&type=template&id=6932f665&scoped=true&"
import script from "./researchHome.vue?vue&type=script&lang=js&"
export * from "./researchHome.vue?vue&type=script&lang=js&"
import style0 from "./researchHome.vue?vue&type=style&index=0&id=6932f665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932f665",
  null
  
)

export default component.exports